<template>
	<div>
		<date-filter :filters="filters" :setups-count="filteredSetups.length" @filter-changed="applyFilter"></date-filter>

		<bike-equipment :quotation_id="quotation_id" :setups="filteredSetups"></bike-equipment>
	</div>
</template>

<script>
import DateFilter from './DateFilter.vue';
import BikeEquipment from './BikeEquipment.vue';

export default {
	name: 'BikeFilterContainer',
	components: {
		DateFilter,
		BikeEquipment,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			filters: this.data.general_info.filters,
			setups: this.data.setups,
			filteredSetups: this.data.setups,
			quotation_id: this.data.general_info.quotation_id,
		};
	},
	methods: {
		applyFilter(filter) {
			if (filter === null) {
				this.filteredSetups = this.setups;
			} else {
				const [start, end] = filter.split(' al ');
				this.filteredSetups = this.setups.filter(setup => {
					return setup.inizioVendita === start && setup.fineVendita === end;
				});
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BikeFilterContainer.vue